import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "20",
  fill: "none",
  viewBox: "0 0 24 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "24",
      height: "20",
      fill: "#E3E3E3",
      rx: "10"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#66707A",
      "fill-rule": "evenodd",
      d: "M14.968 5.97a.751.751 0 0 1 1.061 1.061L13.06 10l2.97 2.969a.75.75 0 0 1-1.061 1.06l-2.97-2.969-2.968 2.97a.75.75 0 1 1-1.06-1.061l2.968-2.97L7.97 7.032a.75.75 0 0 1 1.06-1.06L12 8.938z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }